import { getToken, setToken, removeToken, setRouter, setAllRouter } from '@/utils/auth'
import { login, logout, getInfo } from '@/api/login'
import router from '../../router'
import { routes } from '@/router'
import Home from '../../views/Home.vue';
import store from '..';
export default {
    state: {
        info: {
            id: '',
        },
        token: getToken(),
        name: '',
        router: [],
    },
    getter: {
        info: state => state.info
    },
    mutations: {
        SET_TOKEN: (state, token) => {
            state.token = token
        },
        setUserInfo(state, payload) {
            state.info = payload
        },
        username(state, item) {
            state.name = item
        },
        SET_Router: (state, router) => {
            state.router = router
        }
    },
    actions: {
        // 登录
        Login({ commit }, queryparmes) {
            return new Promise((resolve, reject) => {
                login({ username: queryparmes.username, password: queryparmes.password, vCodeId: queryparmes.vCodeId, vCodeValue: queryparmes.vCodeValue }).then((res) => {
                    setToken(111) // res.token
                    commit('SET_TOKEN', 111)//res.token
                    // sessionStorage.setItem('system', res.data.userMenuList[0].id)
                    // let userMenuList = res.data.userMenuList[0].children
                    // sessionStorage.setItem('routerlist', JSON.stringify(userMenuList))
                    // RouterAll(userMenuList)
                    resolve(res)
                }, (err) => {
                    reject(err)
                })
            })
        },
        // 退出系统
        LogOut({ commit, state }) {
            return new Promise((resolve) => {
                commit('SET_TOKEN', '')
                removeToken()
                sessionStorage.removeItem('routerlist')
                sessionStorage.setItem('sid','')
                // location.reload()
                resolve()
            })
        },
    }
}
// export function RouterAll(userMenuList){
//     const sidebarRoutes = filterAsyncRouter(JSON.parse(JSON.stringify(userMenuList)))
//     //只针对题库问卷的新建路由做的处理
//     sidebarRoutes.forEach(item=>{
//         if(item.meta.title == '测评模板'){
//             item.children.push(
//             {
//                 path: '/evaluation/question-bank',
//                 component: () => import ('@views/evaluation/question-bank'),
//                 meta: { title: '题库管理', icon: '' },
//                 hidden:true,
//             },
//             {
//                 path: '/evaluation/question-revise',
//                 component: () => import ('@views/evaluation/question-revise'),
//                 meta: { title: '题库管理', icon: '' },
//                 hidden:true,
//             },
//             {
//                 path: '/evaluation/questionnaire-add',
//                 component: () => import ('@views/evaluation/questionnaire-add'),
//                 meta: { title: '题库管理', icon: '' },
//                 hidden:true,
//             },
//             )
//         }
//     })
//     sidebarRoutes.push({path: '/', redirect: sidebarRoutes[0].path,hidden:true})
//     router.addRoutes(sidebarRoutes)
//     let RouterList =  routes.concat(sidebarRoutes) 
//     store.commit('SET_Router', RouterList) 
//     setRouter(JSON.stringify(sidebarRoutes))  //动态路由分组
//     setAllRouter(JSON.stringify(RouterList))  //总路由分组
// }
// 遍历后台传来的路由字符串，转换为组件对象
// function filterAsyncRouter(asyncRouterMap) {
//     let includeObj = ['path','redirect','component','meta','hidden','children']
//     asyncRouterMap.forEach(item=>{
//         item.path = item.menuLink
//         item.redirect = item.children[0].menuLink
//         item.component = Home
//         item.hidden = false
//         item.meta = {title: item.menuNm,icon:'inbox'}
//         item.children.forEach(arr=>{
//             arr.path = arr.menuLink
//             arr.component = arr.menuLink
//             arr.hidden = false
//             arr.meta = {title: arr.menuNm,icon:''}
//             for(var key in arr){
//                 if(!includeObj.includes(key)) delete arr[key] && delete arr['children']
//             }
//         })
//         for(var key in item){
//             if(!includeObj.includes(key)) delete item[key]
//         }
//     })
//     return asyncRouterMap.filter(route => {
//       if (route.children && route.children.length) {
//         route.children = filterChildren(route.children)
//       }
//       return true
//     })
//   }

//   function filterChildren(childrenMap) {
//     childrenMap.forEach((el) => {
//         el.component = loadView(el.component)
//     })
//     return childrenMap
//   }
//   export const loadView = (view) => { // 路由懒加载
//     return (resolve) => require([`@/views${view}`], resolve)
//   }